import React, { forwardRef } from 'react';
import * as S from './Styled';

const CatMenuTriggerButton = forwardRef(({ onToggleMenu, showMenu, shortLabel, children, style, ...props }, ref) => {
  return (
    <S.Button
      {...props}
      size="small"
      type="primary"
      onClick={() => onToggleMenu(!showMenu)}
      ref={ref}
      style={style}
    >
      {shortLabel ? (
        <>
          <S.LabelFull>{children}</S.LabelFull>
          <S.LabelShort>{shortLabel}</S.LabelShort>
        </>
      ) : children}
    </S.Button>
  );
});

export default CatMenuTriggerButton;